import lodashGet from 'lodash/get';
import { BRIDGE_RESPONSE_TYPE, BRIDGE_RESPONSE_CODE } from '../interface/common';
import { CustomError } from '../config/bridgeError';
import { inWindow, isElectron } from '@/config';
import { Interceptor } from './interceptor';
import { api as masterApi } from '@/api/api';
import { SequenceHelper } from '@/api/commonModel';
import { MasterBridgeEngine as WebMasterBridgeEngine } from '../webdriver/webMasterEngine';
import { MainBridgeEngine as WebMainBridgeEngine } from '../webdriver/bridgeMainDriver';
import { isSupportNativeProxy } from '@/api/util';
import { getIsLoginPage } from '../../utils/isLocPage';
export class MasterBridgeApi {
    constructor() {
        this.engine = null;
        this.interceptors = {
            request: new Interceptor('request'),
            response: new Interceptor('response'),
        };
        this.bridgeEnableUse = true;
        this.sequenceHelper = new SequenceHelper();
        this.webMainBridgeEngine = null;
        this.bridgeTempEnableUse = true;
        this.randomMarkNo = `${Math.random()}`.replace('.', '');
        this.systemApi = masterApi.getSystemApi();
        if (!isSupportNativeProxy) {
            return;
        }
        this.init();
    }
    init() {
        if (!inWindow() || window.isBridgeWorker) {
            return;
        }
        if (isElectron()) {
            const isLowMemoryMode = this.systemApi.getIsLowMemoryModeSync();
            if (isLowMemoryMode && !window.isAccountBg) {
                this.bridgeEnableUse = false;
            }
            this.engine = Object.assign(window.electronLib.masterBridgeManage, {
                addWinEvent(name, callback) {
                    console.warn('[bridge]electron暂不支持event事件 请使用eventApi', name, callback);
                },
                removeWinEvent(name) {
                    console.warn('[bridge]electron暂不支持event事件 请使用eventApi', name);
                },
                broadcast2AllWin() {
                    console.warn('[bridge]electron暂不支持event事件 请使用eventApi.broadcast2AllWin');
                },
            });
        }
        else if (getIsLoginPage()) {
        }
        else {
            this.engine = new WebMasterBridgeEngine();
            this.webMainBridgeEngine = new WebMainBridgeEngine();
        }
        this.addDefaultInterceptor();
    }
    createSubPageInWeb() {
        if (!this.webMainBridgeEngine) {
            return;
        }
        console.log('[1.25]小版本跳过创建页面');
    }
    removeSubPageInWeb() {
        if (!this.webMainBridgeEngine) {
            return;
        }
        this.webMainBridgeEngine.removeSubPage();
    }
    addDefaultInterceptor() {
        this.interceptors.request.use({
            resolve: config => {
                if (this.getBgFuncStatus4CurrentPage()) {
                    return Promise.resolve(config);
                }
                throw new CustomError(BRIDGE_RESPONSE_TYPE.REJECT_BRIDGE_BY_CURPAGE, {
                    code: BRIDGE_RESPONSE_CODE.REJECT_BRIDGE_BY_CURPAGE,
                    config,
                });
            },
        });
    }
    getSeqNo(namespace, prefixSeqNo) {
        return [prefixSeqNo, namespace, this.randomMarkNo, this.sequenceHelper.next()].join('-');
    }
    async requestData(params, _account = '') {
        var _a;
        const { namespace, apiname, args } = params;
        const account = typeof _account === 'string' && _account.length ? _account : lodashGet(this.systemApi.getCurrentUser(), 'accountMd5', '');
        const seqNo = this.getSeqNo(namespace, account);
        try {
            const configParams = Object.freeze({
                namespace,
                apiname,
                args,
                seqNo,
                account,
            });
            const config = (await this.interceptors.request.excute(Promise.resolve(configParams), ns => ['common', namespace].includes(ns)));
            const _request = (_a = this.engine) === null || _a === void 0 ? void 0 : _a.dispatchTask(config, seqNo);
            const res = (await _request);
            await this.interceptors.response.excute(Promise.resolve({
                data: res.data,
                duration: Object.freeze(res.duration),
                ackNo: seqNo,
                config: Object.freeze(config),
            }), ns => ['common', namespace].includes(ns));
            return res.data;
        }
        catch (ex) {
            const errorMsg = lodashGet(ex, 'message', typeof ex === 'string' ? ex : BRIDGE_RESPONSE_TYPE.BRIDGE_ERROR);
            const errorCode = lodashGet(ex, 'code', BRIDGE_RESPONSE_CODE.BRIDGE_ERROR);
            const errorDuration = lodashGet(ex, 'duration', undefined);
            const customError = new CustomError(errorMsg, {
                code: errorCode,
                duration: errorDuration,
                config: {
                    namespace,
                    apiname,
                    args,
                    account,
                },
            });
            return this.interceptors.response.excute(Promise.reject(customError), (ns, type) => (ns === 'common' || [namespace, apiname].join('.').includes(ns)) && type === 'error');
        }
    }
    async flush(accountId) {
        var _a;
        if (isElectron()) {
            (_a = this.engine) === null || _a === void 0 ? void 0 : _a.flush(accountId);
        }
    }
    configureApiPriority(taskInfo, priority, overtime) {
        var _a;
        if (isElectron()) {
            return (_a = this.engine) === null || _a === void 0 ? void 0 : _a.configureApiPriority(taskInfo, priority, overtime);
        }
        return Promise.resolve(true);
    }
    getConfigureTaskPriority() {
        var _a;
        if (isElectron()) {
            return (_a = this.engine) === null || _a === void 0 ? void 0 : _a.getConfigureTaskPriority();
        }
        return Promise.resolve({});
    }
    forbiddenBbWin4CurrPage() {
        this.bridgeEnableUse = false;
    }
    enableBbWin4CurrPage() {
        this.bridgeEnableUse = true;
    }
    getBgFuncStatus4CurrentPage() {
        return this.bridgeEnableUse;
    }
    removeBridgeWin(webId) {
        if (isElectron()) {
            return this.engine.removeBridgeWin(webId);
        }
        return Promise.resolve(true);
    }
    checkBgAlive(account) {
        if (isElectron()) {
            return this.engine.checkBgAlive(account);
        }
        return Promise.resolve(true);
    }
    addWinEvent(eventName, callback) {
        if (isElectron()) {
            return;
        }
        this.engine.addWinEvent(eventName, callback);
    }
    removeWinEvent(eventName, eventId) {
        if (isElectron()) {
            return;
        }
        this.engine.removeWinEvent(eventName, eventId);
    }
    broadcast2AllWin() { }
    forbiddenBridgeOnce() {
        this.bridgeTempEnableUse = false;
    }
    enableBridgeOnce() {
        this.bridgeTempEnableUse = true;
    }
    getBridgeTempStatus() {
        return this.bridgeTempEnableUse;
    }
}
export const masterBridgeInstance = isSupportNativeProxy ? new MasterBridgeApi() : null;
